/** ACT004 小游戏热点（type=29），与控台字段对齐 */

export function normalizeMinigameDisplayMode(raw) {
  return String(raw || 'DIALOG').trim().toUpperCase() === 'PAGE' ? 'PAGE' : 'DIALOG'
}

export function normalizeMinigameSuccessRule(raw) {
  const v = String(raw || 'SCORE').trim().toUpperCase()
  return v === 'CLEARS' || v === 'ALL' || v === 'ANY' ? v : 'SCORE'
}

function normalizeInt(raw, fallback, min, max) {
  const n = parseInt(raw, 10)
  if (!Number.isFinite(n)) return fallback
  return Math.max(min, Math.min(max, n))
}

function normalizeTileImages(raw) {
  const list = Array.isArray(raw) ? raw : []
  return Array.from({ length: 6 }, (_, index) => String(list[index] || '').trim())
}

export function pickMinigameHotspotFields(source) {
  const s = source && typeof source === 'object' ? source : {}
  return {
    miniGameDisplayMode: normalizeMinigameDisplayMode(s.miniGameDisplayMode),
    miniGameKind: 'MATCH3',
    miniGameEntryImg: String(s.miniGameEntryImg || '').trim(),
    miniGameTitle: String(s.miniGameTitle || '').trim(),
    miniGameBoardSize: normalizeInt(s.miniGameBoardSize, 7, 5, 10),
    miniGameDurationSeconds: normalizeInt(s.miniGameDurationSeconds, 60, 10, 600),
    miniGameSuccessRule: normalizeMinigameSuccessRule(s.miniGameSuccessRule),
    miniGameTargetScore: normalizeInt(s.miniGameTargetScore, 300, 10, 999999),
    miniGameTargetClears: normalizeInt(s.miniGameTargetClears, 30, 3, 9999),
    miniGameBackgroundImg: String(s.miniGameBackgroundImg || '').trim(),
    miniGameSuccessImg: String(s.miniGameSuccessImg || '').trim(),
    miniGameFailureImg: String(s.miniGameFailureImg || '').trim(),
    miniGameTileImgs: normalizeTileImages(s.miniGameTileImgs)
  }
}

export function isMinigameHotspotType(type) {
  return String(type == null ? '' : type).trim() === '29'
}

export function isMinigamePageMode(hotspot) {
  return isMinigameHotspotType(hotspot && hotspot.type) &&
    normalizeMinigameDisplayMode(hotspot && hotspot.miniGameDisplayMode) === 'PAGE'
}
